import axios from 'axios';
import APIUtils from './APIUtils';
import LocaleUtils, { LanguageObject } from './LocaleUtils';
import ProvinceUtils, { Province } from './ProvinceUtils';

interface SectorOfCare {
  id: number;
  key: string;
  province: Partial<Province>;
  name_long: LanguageObject;
  name_short: LanguageObject;
}

const sectorOfCare = {
  generateDefault: (item?: Partial<SectorOfCare>): Partial<SectorOfCare> => {
    return {
      id: item?.id,
      key: item?.key,
      province: ProvinceUtils.province.generateDefault(item?.province),
      name_long: LocaleUtils.langobj.generate(item?.name_long),
      name_short: LocaleUtils.langobj.generate(item?.name_short),
    };
  },

  api: {
    list: async (params?: { province_key: string }) => {
      const resp = await axios.get<SectorOfCare[]>('sectorsOfCare/list.php', {
        params: params,
      });
      return resp.data;
    },
    get: async (id: number | string, province_key?: string) => {
      const resp = await axios.get<SectorOfCare>('sectorsOfCare/get.php', {
        params: { id: id, province_key: province_key },
      });
      return resp.data;
    },
    create: async (item: Partial<SectorOfCare>) => {
      const resp = await axios.post<SectorOfCare>('sectorsOfCare/create.php', {
        ...APIUtils.clean(item),
      });
      return resp.data;
    },
    update: async (item: Partial<SectorOfCare>) => {
      const resp = await axios.put<SectorOfCare>('sectorsOfCare/update.php', {
        ...APIUtils.clean(item),
      });
      return resp.data;
    },
    remove: async (id: number) => {
      const resp = await axios.delete<SectorOfCare>(
        'sectorsOfCare/remove.php',
        {
          params: { id: id },
        }
      );
      return resp.data;
    },
  },
};

export default { sectorOfCare };
export { SectorOfCare };
